import { batchVoteAddress, dCultAddress, governanceAddress } from "./Addresses";
import batchVoteABI from "../Common/ABI/batchVoteABI";
import dCultABI from "../Common/ABI/dCultABI";
import { toast } from "react-toastify";
import governanceABI from "../Common/ABI/governanceABI";


export const nonces = async (account, web3Instance) => {
  try {
    const cultDaoContract = new web3Instance.eth.Contract(dCultABI, dCultAddress);
    return await cultDaoContract.methods.nonces(account).call();
  } catch (e) {
    return "";
  }
};
export const delegateBySigs = async (resData, account, web3Instance) => {
  try {
    const batchVoteContract = new web3Instance.eth.Contract(batchVoteABI, batchVoteAddress);
    return await batchVoteContract.methods
      .delegateBySigs(resData)
      .send({ from: account });
  } catch (e) {
    toast.error(e.message);
    return "";
  }
};
export const castVoteBySigs = async (reqData, account, web3Instance) => {
  try {
    const batchVoteContract = new web3Instance.eth.Contract(batchVoteABI, batchVoteAddress);
    return await batchVoteContract.methods
      .castVoteBySigs(reqData)
      .send({ from: account });
  } catch (e) {
    return "";
  }
};

export const getReceipt = async (proposalId, account, web3Instance) => {
  try {
    const governanceContract = new web3Instance.eth.Contract(
      governanceABI,
      governanceAddress
    );
    return await governanceContract.methods
      .getReceipt(proposalId, account)
      .call();
  } catch (e) {
    return "";
  }
};
